// extracted by mini-css-extract-plugin
export default {"root":"yvmYBKiH6R1vlShFjid5","loginButton":"flmDKXurAV0TRnEWYTjE"};